<template>
  <div class="ui-wrapper">
    <user-identification-item
      image="/assets/images/sim-mtel.svg"
      :title="$t('checkout.identifyUser.existingContract')"
      :buttonText="$t('common.continue')"
      contractType="userIdentificationExisting"
      @update-component="updateComponent"/>
    <div class="ui-separator">
      <span class="ui-separator-round">{{ $t('common.or') }}</span>
    </div>
    <user-identification-item
      image="/assets/images/sim-alt.svg"
      :title="$t('checkout.identifyUser.newContract')"
      :buttonText="$t('common.continue')"
      contractType="new"
      @update-component="updateComponent"/>
  </div>
</template>

<script>
import UserIdentificationItem from '@/components/checkout/user-identification/user-identification-item'

export default {
  name: 'user-identification-wrapper',
  components: { UserIdentificationItem },

  methods: {
    updateComponent (payload) {
      this.$emit('update-component', payload)
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-wrapper {
  padding: 4.8rem 2.4rem;
  background: $white;

  @media (map_get($breakpoints, sm)) {
    display: flex;
    justify-content: center;
    padding: 8rem 2.4rem;
  }
}

.ui-separator {
  position: relative;
  margin: 5rem 0 4rem;

  @media (map_get($breakpoints, sm)) {
    display: flex;
    align-items: center;
    margin: 0;
  }

  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: .1rem;
    background: $separate-line;

    @media (map_get($breakpoints, sm)) {
      top: -8rem;
      left: 50%;
      width: .1rem;
      height: calc(100% + 16rem);
    }
  }
}

.ui-separator-round {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: .1rem solid $border-color-alt;
  border-radius: 50%;
  margin: 0 auto;
  width: 4.8rem;
  height: 4.8rem;
  background: $white;
  z-index: 1;
  text-transform: uppercase;
}
</style>
